import * as React from 'react';

import PropTypes from 'prop-types';

const entityBackgroundColorMap = {
    leads: '#EFFFFB',
    contacts: '#EAFBFF',
    accounts: '#F5F4FF',
};

export default class BoxDragPreview extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
    };

    render() {
        const {title, width, type} = this.props;

        const styles = {
            display: 'inline-block',
            width: width,
            backgroundColor: entityBackgroundColorMap[type],
            padding: '5px 10px',
            opacity: '0.8',
            border: '1px solid #e1e1e1',
            fontWeight: 500,
        };

        return <div style={styles}>{title}</div>;
    }
}
